import StyledAdmin from "./Admin";
export const Admin = StyledAdmin;
